import { Typography, styled } from "@mui/material"
import { PageSubtitle } from "../../PageHeader"
import {
  FullWidthHeaderLayout,
  type FullWidthHeaderLayoutBaseProps,
  TitleContainer,
  TopTitleContainer,
} from "../common"

export type FullWidthHomeHeaderProps = {
  topTitle?: string
} & FullWidthHeaderLayoutBaseProps

export const FullWidthHomeHeader = ({
  title,
  chip,
  level,
  subtitle,
  topTitle,
}: FullWidthHomeHeaderProps) => {
  return (
    <FullWidthHeaderLayout>
      <TopTitleContainer>
        <TopTitle>{topTitle}</TopTitle>
      </TopTitleContainer>
      <TitleContainer level={level} title={title} chip={chip}>
        {!!subtitle && (
          <PageSubtitle sx={{ fontWeight: 400, fontSize: 14 }}>
            {subtitle}
          </PageSubtitle>
        )}
      </TitleContainer>
    </FullWidthHeaderLayout>
  )
}

const TopTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(18),
  color: theme.palette.common.darkBlue,
}))
